export const agentRequests = {
  page: {
    filters: {
      accommodation: "Hébergement",
      type: "Type",
    },
    subtitle: "Ce que vos voyageurs ont demandé via l'agent.",
    clearFilters: "Effacer les filtres",
    loadMore: "Voir plus",
    empty: "Aucune demande pour le moment.",
    emptyFiltered: "Aucune demande avec ces filtres.",
    columns: {
      type: "Type",
      guest: "Voyageur",
      asks: "Demande",
      channel: "Canal",
      status: "Statut",
      when: "Quand",
      amount: "Montant",
    },
  },
  // La columna Importe: en qué quedó el cobro de cada solicitud.
  amount: {
    paid: "Payé",
    awaiting: "En attente de paiement",
    property: "À payer sur place",
    void: "Non facturé",
    quote: "Proposé",
  },
  common: {
    title: "Demandes de la réception IA",
  },
  widget: {
    iaBadge: "IA",
    subtitle: "Ce que vos clients ont demandé via l'agent.",
    todayOn: "Affichage d'aujourd'hui uniquement",
    todayOff: "Afficher uniquement les demandes d'aujourd'hui",
    today: "Aujourd'hui",
    entersToday: "Arrive aujourd'hui",
    entersTodayTitle: "Cette réservation arrive aujourd'hui",
    test: "test",
    approve: "Approuver",
    otherTime: "Un autre horaire",
    prioritize: "Prioriser",
    reject: "Refuser",
    dismiss: "Retirer du panneau",
    loading: "Chargement des demandes…",
    empty: "Aucune demande pour le moment.",
    emptySub: "Lorsqu'un client demande un check-out tardif, un check-in anticipé ou des nuits supplémentaires, cela apparaîtra ici.",
    viewAll: "Voir toutes les demandes",
    entryTime: "Heure de check-in",
    cancel: "Annuler",
    rejectIrreversible: "Cette action est irréversible.",
    modal: {
      approveTitle: "Approuver la demande ?",
      approveTimeTitle: "Approuver à un autre horaire ?",
      tentativeTitle: "Prioriser cette arrivée ?",
      rejectTitle: "Refuser la demande ?",
      defaultTitle: "Confirmer ?",
      approveText: "Vous êtes sur le point d'approuver le check-in anticipé pour",
      approveTimeText: "Vous confirmerez le check-in à l'horaire que vous définissez pour",
      tentativeText: "Nous lui dirons que vous ferez tout votre possible pour que ce soit prêt à cette heure, même si cela dépend du départ précédent et du ménage. Envoyé à",
      rejectText: "Vous êtes sur le point de refuser le check-in anticipé pour",
      defaultText: "Confirmer pour",
      approveCta: "Oui, approuver",
      approveTimeCta: "Confirmer l'horaire",
      tentativeCta: "Oui, notifier",
      rejectCta: "Oui, refuser",
      defaultCta: "Confirmer",
    },
  },
  drawer: {
    close: "Fermer",
    allAccommodations: "Tous les hébergements",
    allTypes: "Tous les types",
    today: "Aujourd'hui",
    yesterday: "Hier",
    from: "Du",
    to: "Au",
    clear: "Effacer",
    writeWhatsapp: "Message sur WhatsApp",
    noMessages: "Aucun message enregistré pour cette conversation.",
    pause: "Pause",
    play: "Lecture",
    downloadMp3: "Télécharger le MP3",
    viewReservation: "Voir la réservation",
    loading: "Chargement…",
    emptyFiltered: "Aucune demande ne correspond à ces filtres.",
    end: "Plus de demandes.",
    features: {
      early: "Check-in anticipé",
      late: "Check-out tardif",
      extend: "Prolonger le séjour",
      invoice: "Facture",
      handoff: "Action requise",
      callMessage: "Messages d'appel",
    },
    channels: {
      call: "Appel",
    },
  },
  box: {
    rooms: "{count} chambre | {count} chambres",
    nights: "{count} nuit | {count} nuits",
    guests: "{count} client | {count} clients",
    earlyRequestedTitle: "Check-in anticipé demandé",
    arrivalRequestedTitle: "Heure d'arrivée demandée",
    early: "Anticipé",
    arrives: "Arrive",
  },
};
